// Components==============
import { useSliderValue } from 'hooks/useSliderValue';
import { ReflectionItemContext } from 'pages/Growth/Reflect/components/ReflectionItem/ReflectionItem';
import React, { useContext, useEffect, useState } from 'react';
import './Slider.module.scss';
// =========================

export default function Slider({
  value,
  setValue,
}: {
  value: number;
  setValue?: React.Dispatch<React.SetStateAction<number>>;
}) {
  const initialValue = value ? (value === 1 ? 1 : (100 / 8) * value) : 50;
  const [sliderPosition, setSliderPosition] = useState(initialValue);

  useEffect(() => setSliderPosition(initialValue), [value]);

  const { save, saveState } = useContext(ReflectionItemContext);
  const sliderValue = useSliderValue(value);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (!setValue) return;
    const currentPosition = parseInt(e.target.value);
    setSliderPosition(currentPosition);

    if (currentPosition >= 0 && currentPosition <= 12) return setValue(1);
    if (currentPosition > 12 && currentPosition <= 25) return setValue(2);
    if (currentPosition > 25 && currentPosition <= 37) return setValue(3);
    if (currentPosition > 37 && currentPosition <= 50) return setValue(4);
    if (currentPosition > 50 && currentPosition <= 62) return setValue(5);
    if (currentPosition > 62 && currentPosition <= 75) return setValue(6);
    if (currentPosition > 75 && currentPosition <= 87) return setValue(7);
    if (currentPosition > 87 && currentPosition <= 100) return setValue(8);
  }

  function handleRelease() {
    if (!setValue) return;
    save({ ...saveState, result: value });
  }

  return (
    <div
      styleName={`container ${value ? 'changed' : ''} ${
        !setValue ? 'inactive' : ''
      }`}
    >
      <input
        type="range"
        min="0"
        max="100"
        styleName="slider"
        onChange={handleChange}
        onPointerUp={handleRelease}
      />
      <div
        styleName="progress"
        style={{
          minWidth: 19,
          width: `${sliderPosition}%`,
        }}
      />
      <p
        style={{
          left: value === 1 || value === 8 ? '' : `${sliderPosition}%`,
          right: value === 8 ? 0 : '',
          transform: value === 1 || value === 8 ? 'none' : '',
        }}
      >
        {sliderValue}
      </p>
    </div>
  );
}
